function FearOrigin({ text }) {
  return (
    <section className="glass-panel rounded-lg p-6">
      <h2 className="font-display text-3xl text-museum-bone">Why it exists</h2>
      <p className="mt-4 leading-8 text-museum-muted">{text}</p>
    </section>
  );
}

export default FearOrigin;
